<template>
	<div>
        <div class="container">
            <notifications position="bottom center" animation-type="velocity" :duration="1500">
                <template slot="body" slot-scope="props">
                    <div class="notification has-text-weight-semibold" v-bind:class="props.item.type">
                        <button class="delete" @click="props.close"></button>
                        <div v-html="props.item.text"></div>
                    </div>
                </template>
            </notifications>

            <div class="columns">
                <div class="column is-two-thirds-tablet is-offset-2-tablet is-half-desktop is-offset-one-quarter-desktop">
                    <router-link to="/"><img :src="$store.getters.assetsUrl + 'logos/viessmann-konto-logo-black.png'" class="logo" alt="Viessmann Konto"></router-link>

                    <transition name="slide-view" mode="out-in">
                        <router-view></router-view>
                    </transition>

                    <div class="buttons has-margin-top is-centered system-btns">
                        <a class="button has-text-weight-semibold is-small is-black is-rounded" :href="proUrl" target="_blank">Viessmann PRO</a><br>
                        <a class="button has-text-weight-semibold is-small is-black is-rounded" :href="iavUrl" target="_blank">Interaktywna Akademia Viessmann</a><br>
                    </div>
                    <img :src="$store.getters.assetsUrl + 'characters/klaus/3D/klaus-greeter-no-shadow.png'" alt="Klaus" class="klaus"/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.subtitle.no-data {
    opacity: .4;
    text-align: center;
    margin-top: 3rem;
}

.logo {
    width: 50%;
    max-width: 200px;
    margin-bottom: 3rem;
}

@media screen and (min-width: 1300px) {
    .logo {
        margin-bottom: 3rem;
    }
}

.klaus {
    display: block;
    width: 100px!important;
    /*filter: drop-shadow(0px 2px 2px #aaa);*/
    z-index: 2;
    margin: 0 auto auto;
    padding-top: 25px;
}


@media screen and (min-width: 768px) {
    .klaus {
        padding-top: 50px;
        width: 250px!important;
        overflow: hidden;
    }
}
</style>

<script>
export default {
    computed: {
        bzuUrl() {
            return process.env.VUE_APP_BZU_URL;
        },
        ePartnerUrl() {
            return process.env.VUE_APP_EPARTNER_URL;
        },
        proUrl() {
            return process.env.VUE_APP_PRO_URL;
        },
        iavUrl() {
            return process.env.VUE_APP_IAV_URL;
        }

    }
}
</script>